import { reactive, toRefs } from "vue";
export default {
  name: "ScoreTable1Body2",
  props: {
    item: {
      type: String,
      default: ''
    },
    score1: {
      type: Number,
      default: -2
    },
    score2: {
      type: Number,
      default: -1
    },
    score3: {
      type: Number,
      default: 2
    },
    score4: {
      type: Number,
      default: 3
    },
    score5: {
      type: Number,
      default: 4
    },
    score6: {
      type: Number,
      default: 5
    },
    score: {
      type: Number
    },
    isSum: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const data = reactive({
      scoreV: props.score
    });
    const handleChange = value => {
      context.emit('update:score', Number(value));
    };
    return {
      ...toRefs(data),
      handleChange
    };
  }
};